module.exports = __webpack_public_path__ + "img/walmart.1fc442d0.svg";